export function parseFilename(value: string): [string, string] {
    const index: number = value.lastIndexOf('.');
    if (index === -1) {
        return [value, ''];
    }

    return [value.substring(0, index), value.substring(index + 1)];
}